import clone from 'lodash/clone';
import { writeCsv, writeCsvOfObjects } from 'utils/writeCsv';
import saveToFileSystem from './saveToFileSystem';
import getAllPaginated from './getAllPaginated';

export const downloadAsCsv =
  (uri, params = {}) =>
  dispatch => {
    const { fromObjects, name, dataTransform = clone } = params;

    return getAllPaginated(
      uri,
      params,
    )(dispatch).then(data => {
      const results = dataTransform(data);
      const csv = fromObjects ? writeCsvOfObjects(results) : writeCsv(results);
      saveToFileSystem(csv, name || uri);
      return results;
    });
  };
